import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import {
  API_SERVICE_CONFIG,
  IApiServiceConfig,
} from '../base/configuration/api-service-config';
import { Observable } from 'rxjs';
import {
  ActivityConfiguration,
  ActivityConfigurationInput,
  AssetConfiguration,
  AssetConfigurationInput,
  SchedulingConfiguration,
  SchedulingConfigurationInput,
  WorkOrderConfiguration,
  WorkOrderConfigurationInput,
} from './typed-tenant-configuration';

@Injectable({ providedIn: 'root' })
export class ApiTypedTenantConfigurationService {
  private readonly url = this.config.url + 'tenants/configurations/v2';

  constructor(
    private http: HttpClient,
    @Inject(API_SERVICE_CONFIG) private config: IApiServiceConfig,
  ) {}

  getSchedulingConfig(): Observable<SchedulingConfiguration> {
    return this.http.get<SchedulingConfiguration>(this.url + '/scheduling');
  }

  updateSchedulingConfig(
    input: SchedulingConfigurationInput,
  ): Observable<void> {
    return this.http.patch<void>(this.url + '/scheduling', input);
  }

  getWorkOrderConfig(): Observable<WorkOrderConfiguration> {
    return this.http.get<WorkOrderConfiguration>(this.url + '/work-orders');
  }

  updateWorkOrderConfig(input: WorkOrderConfigurationInput): Observable<void> {
    return this.http.patch<void>(this.url + '/work-orders', input);
  }

  getActivityConfig(): Observable<ActivityConfiguration> {
    return this.http.get<ActivityConfiguration>(this.url + '/activities');
  }

  updateActivityConfig(input: ActivityConfigurationInput): Observable<void> {
    return this.http.patch<void>(this.url + '/activities', input);
  }

  getAssetConfig(): Observable<AssetConfiguration> {
    return this.http.get<AssetConfiguration>(this.url + '/assets');
  }

  updateAssetConfig(input: AssetConfigurationInput): Observable<void> {
    return this.http.patch<void>(this.url + '/assets', input);
  }
}
